<template>
  <div class="etapa01">
    <fccTable
      striped
      hover
      :fields="fields"
      :orderby="sortBy"
      :actions="actions"
      addFilter
      :items="listagemPublicacao"
      responsive
      :porPage="itemPorPage"
      search
      pagination
      fieldVisibility
      pdf
      csv
      xls
      :titlePage="titlePage"
      :titlePDF="titlePDF"
    >
    </fccTable>
    <fccModal
      centered
      idModal="deparaFieldModal"
      titleModal="Depara de campos"
      escondeFooter
      travaEsc
      travaBack
      size="lg"
    >
      <b-row>
        <b-col sm="5">
          Campos
          <v-select
            :options="lstPublicacao"
            v-model="lstPublicacaoChange"
            placeholder="Selecione"
            label="camponovo"
          >
          </v-select>
        </b-col>
        <b-col sm="5" v-if="lstPublicacaoChange.id !== undefined">
          Campos mysql
          <v-select
            :options="lstMysql"
            v-model="lstMysqlChange"
            placeholder="Selecione"
            label="coluna"
          >
          </v-select>
        </b-col>
        <b-col sm="2">
          <div
            class="buttonsPadraoModal"
            v-if="lstPublicacaoChange.id !== undefined && lstMysqlChange.coluna !== undefined"
          >
            <button
              v-b-tooltip.hover
              title="Adicionar"
              @click="addCampoDepara"
              class="btn btn-light border shadow-sm ml-2 text-dark"
            >
              <font-awesome-icon icon="plus" size="lg" />
            </button>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <fccTable
            striped
            hover
            :fields="fieldsMysql"
            :orderby="sortBy"
            :actions="actionsMysql"
            modal
            :items="lstTabelaDepara"
            responsive
            :porPage="itemPorPage"
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          />
        </b-col>
      </b-row>
    </fccModal>
    <fccModal
      centered
      idModal="addDeparaModal"
      titleModal="Depara campos especiais"
      escondeFooter
      size="lg"
      travaEsc
      travaBack
    >
      <fccDeparaComplementares
        v-if="deparaItem != null"
        :lstMysql="lstMysql"
        :fieldsMysql="fieldsMysql"
        :sortBy="sortBy"
        :titlePage="titlePage"
        :itemPorPage="itemPorPage"
        :deparaItem="deparaItem"
        @listandoDepara="listandoDepara"
        :lstTabelaDepara="lstPublicacao"
      />
    </fccModal>
    <fccModal
      centered
      idModal="addSqlServer"
      titleModal="Criar tabela mysql"
      escondeFooter
      size="lg"
      travaEsc
      travaBack
    >
      <FccCriarSQL :spiItem="spiItem" @fechaModal="fechaModal"></FccCriarSQL>
    </fccModal>
    <fccModal
      centered
      idModal="addFieldModal"
      titleModal="Nova Publicação"
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="criarPublicacao" autocomplete="off">
        <div class="my-2">
          <b-row>
            <b-col sm="6">
              <fccSpi v-model="criar.spi"></fccSpi>
            </b-col>
            <b-col>
              <b-form-checkbox v-model="criar.seminario"> Seminários e cursos </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row class="my-2">
            <b-col sm="12">
              Tipo de Publicação (*)
              <fccTipoPublicacao
                v-on:changesTipoPublicacao="changeTipoPublicacao"
              ></fccTipoPublicacao>
              <input v-model="criar.idpublictipo" type="hidden" />
            </b-col>
          </b-row>
          <div class="row my-2" v-if="criar.idpublictipo">
            <div class="col-sm-12">
              <div class="publicaBox">
                <span class="titlePublicaBox">Publicação</span>
                <div class="row">
                  <div class="col-sm-6 mt-1 fccSirsdate">
                    Data início
                    <datetime
                      value-zone="America/Sao_Paulo"
                      type="date"
                      format="dd/MM/yyyy"
                      class="form-control"
                      placeholder="__/__/____"
                      :min-datetime="dataAtualSGP"
                      v-model="criar.publicacaodata.dtinicio"
                      required
                    ></datetime>
                  </div>
                  <div class="col-sm-6 mt-1 fccSirsdate" v-if="criar.publicacaodata.dtinicio">
                    Horário Inicial
                    <datetime
                      value-zone="America/Sao_Paulo"
                      input-id="horaInicial"
                      type="time"
                      v-model="horaInicial"
                      placeholder="HH:mm"
                      required
                      class="form-control"
                    ></datetime>
                  </div>
                </div>
                <div class="row" v-if="criar.publicacaodata.dtinicio">
                  <div class="col-sm-6 mt-1 fccSirsdate">
                    Data Fim
                    <datetime
                      value-zone="America/Sao_Paulo"
                      type="date"
                      :min-datetime="criar.publicacaodata.dtinicio"
                      format="dd/MM/yyyy"
                      class="form-control"
                      placeholder="__/__/____"
                      v-model="criar.publicacaodata.dtfim"
                      :required="criar.idpublictipo === 1"
                    ></datetime>
                  </div>
                  <div class="col-sm-6 mt-1 fccSirsdate" v-if="criar.publicacaodata.dtfim">
                    Horário Final
                    <datetime
                      value-zone="America/Sao_Paulo"
                      input-id="horaInicial"
                      type="time"
                      v-model="horaFinal"
                      placeholder="HH:mm"
                      required
                      class="form-control"
                    ></datetime>
                  </div>
                </div>
              </div>
              <template v-if="criar.idpublictipo === 1">
                <div class="row">
                  <div class="col-sm-6 mt-1">
                    <div class="publicaBox">
                      <span>Início Geração de Boleto(*)</span>
                      <div class="row">
                        <div class="col-sm-12 mt-1">
                          <datetime
                            value-zone="America/Sao_Paulo"
                            type="datetime"
                            format="dd/MM/yyyy HH:mm"
                            class="form-control"
                            placeholder="__/__/____ __:__"
                            v-model="criar.datapagamentoboleto"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 mt-1">
                    <div class="publicaBox">
                      <span>Término Geração de Boleto(*)</span>
                      <div class="row">
                        <div class="col-sm-12 mt-1">
                          <datetime
                            value-zone="America/Sao_Paulo"
                            type="datetime"
                            format="dd/MM/yyyy HH:mm"
                            class="form-control"
                            placeholder="__/__/____ __:__"
                            v-model="criar.boletohorario"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6 mt-1">
                    <div class="publicaBox">
                      <span>Confirmação do pagamento(*)</span>
                      <div class="row">
                        <div class="col-sm-12 mt-1">
                          <datetime
                            value-zone="America/Sao_Paulo"
                            type="datetime"
                            format="dd/MM/yyyy HH:mm"
                            class="form-control"
                            placeholder="__/__/____ __:__"
                            v-model="criar.dataconfirmacaopagamento"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 mt-1">
                    <div class="publicaBox">
                      <span>Pix Data de Pagamento(*)</span>
                      <div class="row">
                        <div class="col-sm-12 mt-1">
                          <datetime
                            value-zone="America/Sao_Paulo"
                            type="datetime"
                            format="dd/MM/yyyy HH:mm"
                            class="form-control"
                            placeholder="__/__/____ __:__"
                            v-model="criar.pixhorario"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-sm-12">
                    <div class="publicaBox">
                      <span class="titlePublicaBox">Cidades</span>
                      <fcc-input v-model="criar.qtdecidade" type="number" class="mt-3" required>
                        Qtde. de Cidades de Exame</fcc-input
                      >
                      <hr />
                      <div class="row mt-2" v-if="criar.qtdecidade == 1">
                        <fcc-input
                          disabled
                          v-model="cidade.codcidexame"
                          required
                          type="number"
                          class="col-sm-4 mt-1"
                        >
                          Código Cidade</fcc-input
                        >
                        <fcc-input v-model="cidade.descricao" required class="col-sm-8 mt-1">
                          Descrição</fcc-input
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="row my-4">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit" :disabled="criar.qtdecidade < 1">
                {{ labelsSystem.criar }}</fccButton
              >
            </div>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import fccTipoPublicacao from '@/fccComponents/global/fccSpi/fccTipoPublicacao.vue'
import fccDeparaComplementares from '../fccDeparaComplementares/fccDeparaComplementares.vue'
import FccCriarSQL from '../fccCriarSQL/fccCriarSQL.vue'

export default {
  data() {
    return {
      sortBy: 'first_name',
      titlePage: 'Publicações',
      titlePDF: 'Lista de Publicações WEB',
      sortDesc: false,
      sPI: '',
      cidade: {
        codcidexame: 0,
        descricao: ''
      },
      dataAtualSGP: this.capturaDataAtualSGP(),
      passoPublicacao: 1,
      baseUrlPublicacao: '',
      listagemPublicacao: [],
      lstMysql: [],
      lstTabelaDepara: [],
      deparaItem: [],
      spiItem: [],
      lstPublicacao: [],
      lstPublicacaoChange: '',
      lstMysqlChange: '',
      itemPorPage: '100',
      publicacaoId: '',
      textDataTipo: '',
      horaInicial: '',
      horaFinal: '',
      criar: {
        seminario: false,
        idsituacao: 1,
        spi: '',
        dspublicacao: '',
        idpublictipo: '',
        publicacaodata: {
          idpublicdatatipo: 1,
          dtinicio: '',
          dtfim: ''
        },
        qtdecidade: 0,
        idtipopagamento: 0
      },
      fieldsMysql: [
        { key: 'id', label: 'Código', sortable: true, active: true },
        { key: 'camponovo', label: 'Campo', sortable: true, active: true },
        { key: 'campomysql', label: 'Campo Mysql', sortable: true, active: true },
        { key: 'actions', label: '', active: true }
      ],
      actionsMysql: [
        {
          button: true,
          funcaoButton: 'deleteCampoMysql',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      fields: [
        { key: 'idpublicacao', label: 'Código', sortable: true, active: true },
        {
          key: 'datainclusao',
          label: 'Solicitação',
          sortable: true,
          active: true
        },
        { key: 'spi', label: 'SPI', sortable: true, active: true },
        { key: 'dstipopublicacaotipo', label: 'Tipo de Publicação', sortable: true, active: true },
        { key: 'dtinicio', label: 'Publicação', sortable: true, active: true },
        { key: 'dssituacao', label: 'Status', sortable: true, active: true },
        { key: 'actions', label: '', active: true }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editField',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deparaField',
          icon: 'database',
          tooltip: 'Depara de Campos',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deparaFieldEspeciais',
          icon: 'database',
          tooltip: 'Depara de Campos Especiais',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'sqlServer',
          icon: 'plus',
          tooltip: 'Criar tabela',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteField',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  components: {
    fccTipoPublicacao,
    fccDeparaComplementares,
    FccCriarSQL
  },
  methods: {
    deparaFieldEspeciais(_, item) {
      this.listandoDepara(item)
      this.deparaItem = item
      this.$root.$emit('bv::show::modal', 'addDeparaModal')
    },
    sqlServer(_, item) {
      this.spiItem = item
      this.$root.$emit('bv::show::modal', 'addSqlServer')
    },
    fechaModal() {
      this.spiItem = {}
      this.$root.$emit('bv::hide::modal', 'addSqlServer')
    },
    setDate() {
      this.criar.publicacaodata.dtinicio =
        this.criar.publicacaodata.dtinicio === ''
          ? this.horaInicial
          : this.criar.publicacaodata.dtinicio
    },
    deleteField(_, item) {
      this.callConfirm(this.mensagemExcluir, item.spi).then(() => {
        this.deletePublicacao(item.idpublicacao)
          .then(() => {
            this.listandoPublicacoes()
            this.carregaTexto()
            this.callToast(this.mensagensUpdate.excluido)
          })
          .catch((error) => {
            this.setErrorSystem(error)
          })
      })
    },
    deleteCampoMysql(_, item) {
      this.callConfirm(this.mensagemExcluir, item.camponovo).then(() => {
        axios
          .delete(
            this.baseUrlGestaoForm + 'TabelaDeParaPublicacao/Excluir/' + item.id,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.lstPublicacaoChange = ''
            this.lstMysqlChange = ''
            this.listandoDepara(this.deparaItem)
            this.callToast(this.mensagensUpdate.excluido)
            this.carregaTexto()
          })
          .catch((error) => {
            this.setErrorSystem(error)
          })
      })
    },
    changeTipoPublicacao(recebe) {
      this.horaInicial = this.$moment(recebe.horarioiniciopadrao, 'HH:mm:ss').format(
        'YYYY-MM-DDTHH:mm:ss'
      )
      this.horaFinal = this.$moment(recebe.horariofimpadrao, 'HH:mm:ss').format(
        'YYYY-MM-DDTHH:mm:ss'
      )
      this.criar.idpublictipo = recebe.idpublictipo
      this.textDataTipo = recebe.dstipo
      this.setDate()
    },
    criarPublicacao() {
      this.criar.idsituacao = 1
      this.criar.dspublicacao = ''
      this.criar.qtdecidade = parseInt(this.criar.qtdecidade)
      this.criar.publicacaodata.dtinicio = this.FormataTimeStampSGP(
        this.criar.publicacaodata.dtfim,
        this.horaFinal
      )
      this.criar.publicacaodata.dtfim = this.FormataTimeStampSGP(
        this.criar.publicacaodata.dtfim,
        this.horaFinal
      )

      if (this.criar.publicacaodata.dtfim < this.criar.publicacaodata.dtinicio) {
        this.callAlert('Erro ao Inserir', 'Data Final maior que a data inicial', 'error', 'error')
      } else {
        this.carregaTexto(this.codeMensagem('C04'))

        axios
          .post(
            this.baseUrlPublicacao + 'Publicacao/InserirPublicacao',
            this.criar,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            this.publicacaoId = response.data
            let controlePage = {
              titlePublicacao: 'Datas',
              idpublicacao: response.data,
              urllogo: '',
              passoPublicacao: 2,
              spiPublicacao: this.criar.spi,
              idpublictipo: this.criar.idpublictipo,
              tipopublicacao: this.textDataTipo,
              idtipopagamento: this.criar.idtipopagamento,
              boletohorario: this.criar.boletohorario,
              datapagamentoboleto: this.criar.datapagamentoboleto,
              dataconfirmacaopagamento: this.criar.dataconfirmacaopagamento,
              pixhorario: this.criar.pixhorario,
              qtdecidade: this.criar.qtdecidade
            }
            if (this.criar.qtdecidade == 1) {
              const cidade = {
                spi: this.criar.spi,
                codcidexame: this.cidade.codcidexame,
                descricao: this.cidade.descricao,
                fldisponivel: 1
              }
              this.inserirCidadeSPI([cidade])
                .then(() => {
                  this.$emit('changePublicacao', controlePage, true)
                  this.carregaTexto()
                })
                .catch((error) => {
                  this.deletePublicacao(response.data)
                  this.setErrorSystem(error)
                })
            } else {
              this.$emit('changePublicacao', controlePage, true)
              this.carregaTexto()
            }
            this.$root.$emit('bv::hide::modal', 'addFieldModal')
          })
          .catch((error) => {
            this.$root.$emit('bv::hide::modal', 'addFieldModal')
            this.carregaTexto()
            this.setErrorSystem(error)
          })
      }
    },
    formataDataFinal(data) {
      return this.$moment(data, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DDTHH:mm:ss')
    },
    addField() {
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    addCampoDepara() {
      var lista = [
        {
          id: 0,
          idpublicacao: this.lstPublicacaoChange.idpublicacao,
          camponovo: this.lstPublicacaoChange.camponovo,
          campomysql: this.lstMysqlChange.coluna
        }
      ]
      axios
        .post(
          this.baseUrlGestaoForm + 'TabelaDeParaPublicacao/AdicionarTabelaDeParaPublicacao',
          lista,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.lstPublicacaoChange = ''
          this.lstMysqlChange = ''
          this.listandoDepara(this.deparaItem)
          this.carregaTexto()
          this.callToast(this.mensagensUpdate.editado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'deparaFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    deparaField(_, item) {
      this.listandoDepara(item)
      this.deparaItem = item
      this.$root.$emit('bv::show::modal', 'deparaFieldModal')
    },
    listandoDeparaSpi(item) {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlGestaoForm + 'TabelaDeParaPublicacao/ListarCamposNovos/' + item.idpublicacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listandoTabelaDepara(item.idpublicacao)
          this.lstPublicacao = response.data
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    },
    listandoTabelaDepara(item) {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlGestaoForm + 'TabelaDeParaPublicacao/ListarTabelaDeParaPublicacao/' + item,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstTabelaDepara = response.data
          this.lstTabelaDepara.forEach((tabela) => {
            var lstNovo = this.lstPublicacao.find(
              (element) => element.camponovo === tabela.camponovo
            )
            var lstMysqlTabela = this.lstMysql.find((mysql) => mysql.coluna === tabela.campomysql)
            if (lstNovo !== undefined) {
              this.lstPublicacao = this.arrayRemove(this.lstPublicacao, lstNovo)
            }
            if (lstMysqlTabela !== undefined) {
              this.lstMysql = this.arrayRemove(this.lstMysql, lstMysqlTabela)
            }
          })
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    },
    listandoDepara(item) {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlGestaoForm + 'TabelaDeParaPublicacao/ListarCamposMysql/' + item.spi,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstMysql = response.data.tabela
          this.listandoDeparaSpi(item)
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    },
    editField(_, item) {
      item.boletohorario = this.$moment(item.boletohorario, 'DD-MM-YYYYTHH:mm:ss').format(
        'YYYY-MM-DDTHH:mm:ss'
      )
      item.dataconfirmacaopagamento = this.$moment(
        item.dataconfirmacaopagamento,
        'DD-MM-YYYYTHH:mm:ss'
      ).format('YYYY-MM-DDTHH:mm:ss')
      item.pixhorario = this.$moment(item.pixhorario, 'DD-MM-YYYYTHH:mm:ss').format(
        'YYYY-MM-DDTHH:mm:ss'
      )
      item.passoPublicacao = 2
      this.$emit('changePublicacao', item)
    },
    listandoPublicacoes() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao + 'Publicacao/ListarPublicacao',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemPublicacao = response.data
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    }
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.baseUrlGestaoForm = store.state.baseUrlGestaoForm
    this.listandoPublicacoes()
  }
}
</script>
